import { IFlashcardRepository } from '../../domain/repositories/IFlashcardRepository';

export interface FlashcardAnalyticsDTO {
  totalDecks: number;
  totalCards: number;
  aiGeneratedCards: number;
  manualCards: number;
  activeStudents: number;
  averageRetention: number;
  workspaceStats: WorkspaceFlashcardStats[];
  topDifficultCards: DifficultCardDTO[];
}

export interface WorkspaceFlashcardStats {
  workspaceId: string;
  workspaceName: string;
  deckCount: number;
  cardCount: number;
  activeStudents: number;
  totalReviews: number;
  retentionRate: number;
}

export interface DifficultCardDTO {
  id: string;
  front: string;
  back: string;
  deckTitle: string;
  averageEasiness: number;
  totalReviews: number;
}

export class GetFlashcardAnalyticsUseCase {
  constructor(private readonly repository: IFlashcardRepository) {}

  async execute(): Promise<FlashcardAnalyticsDTO> {
    return this.repository.getFlashcardAnalytics();
  }
}
